import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
import "./WeatherInfo.css";

export default function WeatherInfo(props){
    return ( 
    
     <div className="WeatherInfo"> 
             <h1 id="cityName">{props.data.city}</h1>

<div className="WeatherForecast-icon-temp" id="H2">
  <span className="WeatherIcon"> < WeatherIcon code={props.data.icon} size={70} /> </span>
  <span> </span>
   <span id="celsiusDegrees"> < WeatherTemperature celsius={props.data.temperature} /> </span>
          </div>

      <ul className="data">      
          <li>
            <FormattedDate date={props.data.date} />
            </li>
       <li className="text-capitalize">{props.data.description}</li>
       <li>Wind: {props.data.wind} km/h</li>
       <li>Humidity: {props.data.humidity} %</li> 
       </ul>
       </div>
       );
}